import React from 'react';

import { Status } from '@gogame/components';
import {
  STATUS_DELETED,
  STATUS_DRAFT,
  STATUS_PROCESSING,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_ERROR,
  STATUS_PENDING_DR,
  STATUS_PENDING_BC,
  STATUS_PENDING_VP,
  STATUS_PENDING_PAID,
  STATUS_PENDING_MORE_INFO,
  STATUS_INVOICED,
  STATUS_PARTIALLY_PAID,
  STATUS_PENDING_IO,
  STATUS_SAP_REJECTED,
  STATUS_PENDING_SADJ,
  STATUS_PENDING_TL,
  STATUS_PENDING_COMPLETION,
  STATUS_PENDING_AM,
} from 'scenes/FinancialResults/constants';

export const getColor = (id) => {
  switch (id) {
    case STATUS_DELETED:
      return 'inactive';
    case STATUS_DRAFT:
      return 'draft';
    case STATUS_APPROVED:
      return 'success';
    case STATUS_REJECTED:
    case STATUS_ERROR:
      return 'error';
    case STATUS_PROCESSING:
    case STATUS_PENDING_DR:
    case STATUS_PENDING_BC:
    case STATUS_PENDING_VP:
    case STATUS_PENDING_IO:
    case STATUS_PENDING_SADJ:
    case STATUS_PENDING_TL:
    case STATUS_PENDING_COMPLETION:
    case STATUS_PENDING_AM:
      return 'pending';
    case STATUS_PENDING_PAID:
    case STATUS_PARTIALLY_PAID:
      return 'payment';
    case STATUS_PENDING_MORE_INFO:
    case STATUS_INVOICED:
      return 'info';
    case STATUS_SAP_REJECTED:
      return 'warning';
  }
};

const FRStatus = ({ id, children }) => {
  return <Status color={getColor(id)}>{children}</Status>;
};

export default FRStatus;
